import makeStyles from "@mui/styles/makeStyles";
import { BrandCustom } from "Models/brand.custom";

interface Props {
  currentBrand?: BrandCustom;
}

const styles = makeStyles((theme) => ({
  itemSelected: {
    backgroundColor: (props: Props) => props?.currentBrand?.primaryColor || "#38CFC4",
    color: "#FFFFFF",
  },
}));

export default styles;
